// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); 
  gap: 0.75rem; /* Espaciado entre columnas */
  width: 100%;
}

.grid-column {
  display: flex;
  flex-direction: column;
  gap: 0.375rem; /* Espaciado vertical entre campos */
}



.field {
  display: flex;
  flex-direction: column; /* Etiqueta encima del input */
  gap: 0.2rem; /* Espacio entre etiqueta e input */
}

.checkbox-container {
  display: flex;
  align-items: center; /* Alinear verticalmente el checkbox y el texto */
  gap: 0.5rem; /* Espacio entre el checkbox y su etiqueta */
}

.checkbox-label {
  font-size: 14px; /* Tamaño uniforme con las otras etiquetas */
  color: #333;
  margin: 0; /* Sin margen adicional */
}

.checkbox-container {
  display: flex;
  align-items: center; /* Alinear verticalmente el checkbox y el texto */
  gap: 0.5rem; /* Espacio entre el checkbox y su etiqueta */
}

.checkbox-label {
  font-size: 14px; /* Tamaño uniforme con las otras etiquetas */
  color: #333;
  margin: 0; /* Sin margen adicional */
}
`, "",{"version":3,"sources":["webpack://./src/styles/EditarBLModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY,EAAE,6BAA6B;EAC3C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,oCAAoC;AACrD;;;;AAIA;EACE,aAAa;EACb,sBAAsB,EAAE,8BAA8B;EACtD,WAAW,EAAE,mCAAmC;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,iDAAiD;EACtE,WAAW,EAAE,4CAA4C;AAC3D;;AAEA;EACE,eAAe,EAAE,4CAA4C;EAC7D,WAAW;EACX,SAAS,EAAE,yBAAyB;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,iDAAiD;EACtE,WAAW,EAAE,4CAA4C;AAC3D;;AAEA;EACE,eAAe,EAAE,4CAA4C;EAC7D,WAAW;EACX,SAAS,EAAE,yBAAyB;AACtC","sourcesContent":[".grid-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); \n  gap: 0.75rem; /* Espaciado entre columnas */\n  width: 100%;\n}\n\n.grid-column {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem; /* Espaciado vertical entre campos */\n}\n\n\n\n.field {\n  display: flex;\n  flex-direction: column; /* Etiqueta encima del input */\n  gap: 0.2rem; /* Espacio entre etiqueta e input */\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center; /* Alinear verticalmente el checkbox y el texto */\n  gap: 0.5rem; /* Espacio entre el checkbox y su etiqueta */\n}\n\n.checkbox-label {\n  font-size: 14px; /* Tamaño uniforme con las otras etiquetas */\n  color: #333;\n  margin: 0; /* Sin margen adicional */\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center; /* Alinear verticalmente el checkbox y el texto */\n  gap: 0.5rem; /* Espacio entre el checkbox y su etiqueta */\n}\n\n.checkbox-label {\n  font-size: 14px; /* Tamaño uniforme con las otras etiquetas */\n  color: #333;\n  margin: 0; /* Sin margen adicional */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
